import { registerSW } from 'virtual:pwa-register'

const intervalMS = 30 * 60 * 1000 // refresh app every 30 minutes

registerSW({
  immediate: true,
  onRegisteredSW(swUrl, r) {
    // https://vite-pwa-org.netlify.app/guide/periodic-sw-updates.html
    if (r) {
      setInterval(async () => {
        if (r.installing || !navigator)
        return

        if (('connection' in navigator) && !navigator.onLine)
          return

        try {
          const resp = await fetch(swUrl, {
            cache: 'no-store',
            headers: {
              'cache': 'no-store',
              'cache-control': 'no-cache',
            },
          })
    
          if (resp?.status === 200)
            await r.update()

        } catch (error) {
          if (import.meta.env.DEV) console.error('Error updating service worker:', error)
        }
      }, intervalMS)
    }
  }
})